const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-start-end",
        label: "작성일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      { component: "search-disaster-types", label: "재해형태", value: "disaster", query: { dty: "disaster" }, options: {} },
      {
        component: "search-select",
        label: "조치 현황",
        value: "type",
        query: { s_s: "select" },
        options: {
          default: "전체",
          items: ["전체", "조치 전", "조치 중", "조치 완료"],
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "재해형태", "조치기한", "조치 현황", "조치 완료일", "요청일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({ key: "created_at", operator: ">=", value: search.date.startDate });
      conditions.push({ key: "created_at", operator: "<", value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : "" });
    }

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    if (search.type && search.type !== "전체") {
      conditions.push({ key: "body.조치현황_조치현황", operator: "=", value: search.type });
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({ key: "body.재해형태", operator: "LIKE", value: `%${search.disaster}%` });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "요청자 구분",
        key: "body.요청자구분",
      },
      {
        name: "장소",
        key: "body.장소",
      },
      {
        name: "재해형태",
        key: "body.재해형태",
      },
      {
        name: "조치부서",
        key: "body.조치현황_조치자.section",
      },
      {
        name: "조치자",
        key: "body.조치현황_조치자.name",
      },
      {
        name: "조치 현황",
        key: "body.조치현황_조치현황",
      },
      {
        name: "조치기한",
        key: "body.조치기한",
      },
      {
        name: "조치 완료일",
        key: "body.조치현황_조치완료일",
      },
      {
        name: "요청자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "요청일",
        key: "body.요청일",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContent(value).요청자구분; // 요청자구분
        case 2:
          return func.getContent(value).장소; // 장소
        case 3:
          return func.getContent(value).재해형태; // 재해형태
        case 4:
          return func.getContent(value).조치현황_조치자 && func.getContent(value).조치현황_조치자.section ? func.getContent(value).조치현황_조치자.section : ""; // 조치부서
        case 5:
          return func.getContent(value).조치현황_조치자 && func.getContent(value).조치현황_조치자.name ? func.getContent(value).조치현황_조치자.name : ""; // 조치자
        case 6:
          return func.getContent(value).조치현황_조치현황; // 조치현황
        case 7:
          return func.getContent(value).조치기한; // 조치기한
        case 8:
          return func.getContent(value).조치현황_조치완료일; // 조치완료일
        case 9:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 10:
          return func.getContent(value).요청일 // 요청일
        case 11:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
